import React, { useEffect, useState } from 'react';
import { Dropdown, Modal } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import {Col, Row} from "react-bootstrap";
import { Link } from 'react-router-dom';
import './RegisterModal.css'
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {option} from '../../../../helpers/DropDownOption';
import ThankyouMessage from '../../Components/Message/ThankyouMessage';
import {Api} from "../../../../helpers/Api";
import ShortUniqueId  from "short-unique-id";
import LoadingSpinner from '../../Components/Spinner/LoadingSpinner';
import columnConfig from "../../Main/Dashboard/columns";

const RegisterModal = (props) => {
    
    let config = columnConfig['Registration'];
    
    const uid = new ShortUniqueId({ length: 5 });
    const navigate = useNavigate();

    const [data, setData] = useState({ team:[] });
    const [post, setPost] = useState({});
    const [step, setStep] = useState(1);
    const [isLoading, setIsLoading] = useState(true);

    const validation = () =>{
        if(step == 1 && data.registering_type == 'Team' && (data.max_member == ''|| data.max_member == undefined)){
            return false;
        }

        else if(step == 2 && data.team_name == '' && data.team_name == undefined){
            return false;
        }
        return true;
    }
    const handelSubmit = () =>{
        create();
    }

    const handelSubmitForPament = () =>{
        setIsLoading(true);
        Api.call(`/icicicreate`, "POST", data).then(res => {
           window.open(res.url);
           Next();
        }).catch(console.log).finally(() => {
            setIsLoading(false);
        })
    }

    const create = () => {
            setIsLoading(true);
            Api.call(`/${config.url}`, "POST", data).then(res => {
                console.log(res)
            if(res.message == 'success'){
            Next();}
            }).catch(console.log).finally(() => {
                setIsLoading(false);
            })
        };

    useEffect(()=>{
        let d;
        d = {...data};
        d['template'] = props.id;
        d['uuid'] = uid();
        d.fee = post.fee;
        setData(d);
    },[isLoading])

    useEffect(()=>{
        Api.call(`/getEventById/${props.id}`).then(response => {
            setPost(response);
            console.log(response);
        }).catch(console.log)
        .finally(_ => {
            setIsLoading(false);
        });
    },[]);

    const handelChange = (name,value) =>{
        let undef;
        let d = {...data};
        if(name == 'registering_type' ){
            d.max_member = undef;
        }
        d[name] = value;
        setData(d);
    };

    const handelArrayChange = (name,value,index) =>{
        let d = {...data};
        d['team'][index][name] = value;
        setData(d);
    };

    const Back = () =>{
        setStep(step-1);
    }

    const Next = () =>{
        if(!validation()){
            return;
        }
        setStep(step+1);
    }

    return ((isLoading ) ? <LoadingSpinner /> : <>
    {data.rcount && data.rcount !== 0 ? "Seat is full" :
            <div className='modal-inner-section'>
                <div className='modal-header-section'>
                    <div className='header-section'>
                        <Modal.Header closeButton>
                           
                           { step !== 3 && <Modal.Title>{post.name}</Modal.Title> }
                        </Modal.Header>
                    </div> 
                    { step === 3 && <ThankyouMessage close={props.close} /> }
                    { step !== 3 && <p>{props.para}</p> }
                </div>
                <div className='modal-body-section'>
                    
                    <Form autoComplete={'off'} onSubmit={handelSubmit}>
                        {/* Select Member Type */}
                        {step === 1 && <Form.Group className='form-group'>
                            <Form.Label>Select member *</Form.Label>
                            <Form.Select value={data?.registering_type} aria-label="Default select example" required name='registering_type'
                             onChange={event=>{handelChange(event.target.name, event.target.value,event)}}>
                                <option value='' >Please select</option>
                                <option value="Single">Single</option>
                                <option value="Team">Team</option>
                            </Form.Select>
                        </Form.Group>}

                        {/* For Team Registeration */}
                        {step === 1 && data.registering_type == 'Team' && 
                        <Form.Group className='form-group'>
                            <Form.Label>Select total member *</Form.Label>
                            <Form.Select aria-label="Default select example" value={data?.max_member} required name='max_member'
                            onChange={event=>{handelChange(event.target.name, event.target.value,event)}}>
                               <option value='' >Please select</option>
                                {
                                    option.MemberOption.map((data)=> {
                                      return <option value={data}>{data}</option>
                                    })
                                }
                            </Form.Select>
                        </Form.Group>  
                        }

                        { step === 1 &&  data.registering_type !== undefined && data.registering_type !== '' &&
                        <div className='back-register-button'>
                            <button type="button" onClick={() => {Next()}} className="register-button" style={{height:'42px'}}>Next</button>
                        </div>
                        }


                        {/* Personal-Details And Team Name */}    
                        { step === 2 && <div className='registerfor-single-user'>
                            { data.registering_type == 'Team' && <Row>
                               <Col md={12}>
                                <Form.Group className='form-group'>
                                    <Form.Label>Team name *</Form.Label>
                                        <Form.Control value={data?.team_name} type="text" name="team_name" className='form-fields'
                                            placeholder="Enter team name" onChange={event=>{handelChange(event.target.name, event.target.value)}}/>
                                    </Form.Group>
                                </Col>
                            </Row>}
                            { (()=>{
                                let total_member=[];
                                let max_member = data?.max_member || 1;

                                for (let index = 0; index < max_member; index++) {   
                                if(data.team.length != max_member){
                                    data.team.push({name:'', email:'', phone:''});
                                }
                                total_member.push(
                                <div className='Personal-Details'>
                                <Row>
                                    <h6 className="person-detail">Person {index+1}*</h6>
                                <Col md={4}>
                                    <Form.Group className="form-group">
                                        <Form.Label>Name *</Form.Label>
                                            <Form.Control type="text" name="name" className='form-fields' placeholder="Enter name"
                                                onChange={event=>{handelArrayChange(event.target.name, event.target.value, index)}}/>
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group className="form-group">
                                        <Form.Label>Email address {index+1 == 1 ? '*':''}</Form.Label>
                                        <Form.Control type="email" name="email" className='form-fields' placeholder="Enter email"
                                                onChange={event=>{handelArrayChange(event.target.name, event.target.value, index)}}  />
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group className="form-group">
                                        <Form.Label>Phone number {index+1 == 1 ? '*':''}</Form.Label>
                                        <Form.Control type="number" maxlength="10" name="phone" className='form-fields' placeholder="Enter phone number"
                                                onChange={event=>{handelArrayChange(event.target.name, event.target.value, index)}}  />
                                    </Form.Group>  
                                </Col>
                                </Row>
                                </div>)   
                                }
                                return total_member;
                                })()} 
                        </div>}


                         {/* For step 2 if there is fee */}
                        {step === 2 && data.fee && <div className='registration-fee'>
                            <div className='fee-amount'>
                                <p>Event Fee <span className='actual-amount'> Rs. {data?.fee}</span></p>
                            </div>
                            <div className='back-pay-button'>
                                <Link to="#" onClick={()=>{Back()}} class="back-to-previous">Back</Link>
                                <button type="button" onClick={()=>handelSubmitForPament()} className="pay-button">Pay now</button>
                            </div>
                        </div>}
 
                        {/* For step 2 if there is no fee */}
                        {step === 2 && !data.fee && <div className='back-register-button'>
                            <Link to="#" onClick={()=>{Back()}} class="back-to-previous">Back</Link>
                            <button type="button" onClick={()=>handelSubmit()} className="register-button" style={{height:'42px'}}>Register</button>
                        </div>}

                    </Form>
                </div>
            </div>}
        </>
    )
}

export default RegisterModal;